import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { hotSearches } from "@/mocks/gossip";

function tagClass(tag: string) {
  if (tag === "爆") return "bg-accent-500 text-background-50";
  if (tag === "热") return "bg-secondary-500 text-background-50";
  if (tag === "新") return "bg-primary-500 text-background-50";
  return "hidden";
}

export default function HotSearch() {
  const half = Math.ceil(hotSearches.length / 2);
  const columns = [hotSearches.slice(0, half), hotSearches.slice(half)];

  return (
    <section className="w-full bg-background-100" aria-labelledby="hot-search-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          kicker="实时更新"
          title="今日热搜榜"
          desc="来自全网的讨论热度排行，每半小时刷新一次。点进去可以看到我们整理的时间线，而不是只有一句没头没尾的爆料。"
        />
        <h2 id="hot-search-title" className="sr-only">
          今日热搜榜
        </h2>
        <div className="grid grid-cols-1 gap-x-10 gap-y-1 md:grid-cols-2">
          {columns.map((column, columnIndex) => (
            <ol key={`hot-column-${columnIndex}`} className="divide-y divide-background-200">
              {column.map((item) => (
                <li key={item.id}>
                  <Link
                    to="/plaza"
                    className="group flex items-center gap-3 py-3.5 transition-colors hover:bg-background-200/60 md:gap-4"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                        item.rank <= 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-300/60 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </span>
                    {item.tag && (
                      <span
                        className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-medium ${tagClass(item.tag)}`}
                      >
                        {item.tag}
                      </span>
                    )}
                    <span className="hidden shrink-0 text-xs text-foreground-400 sm:inline">
                      {item.scopeHint}
                    </span>
                    <i
                      className="ri-arrow-right-up-line shrink-0 text-base text-foreground-300 transition-colors group-hover:text-primary-600"
                      aria-hidden="true"
                    ></i>
                  </Link>
                </li>
              ))}
            </ol>
          ))}
        </div>
      </div>
    </section>
  );
}